import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'react-toggle/style.css';
import API from '../../../utils/API';
import FormManager from './formManager';
import TabContainer from '../../../components/views/TabsContainer';
import InputField from '../../../components/inputs/inputField';

import ToggleField from '../../../components/inputs/toggleField';
import SectionHeader from '../../../components/views/SectionHeader';
import CheckInFormBuilderModal from './modals/checkInFormBuilderModal';
import SectionFooter from '../../../components/views/SectionFooter';
import FileChooserPreview from '../../../components/inputs/fileChooserPreview';
import FilesUploaderModal from '../../../components/files/filesUploaderModal';
import baseFieldList from '../../../data/attendeeBaseFieldList';
import SelectField from '../../../components/inputs/selectField';
import CheckinSetup from './setup';
import CheckinFormSetup from './checkinForm';
import WalkinFormSetup from './walkinForm';
import SessionCheckinSetup from './sessionCheckin';
import AddSimpleZebraDeviceModal from './modals/addSimpleZebraDeviceModal';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import RenamePrinterModal from './modals/renamePrinter';
import DisconnectPrinterModal from './modals/disconnectPrinterModal';
import BadgeEditor from '../../../components/badgeEditor';
import LoadingWizard from '../../../components/spinner/wizard';
import ConfigureCheckin from './configure';
class CheckInAppSetup extends Component {
	constructor(props) {
		super(props);
		let tabs = [{ title: 'Setup', id: 'setup' }, { title: 'Configure', id: 'configure' }, { title: 'Check In Form', id: 'checkInForm' }, { title: 'Deploy', id: 'deploy' }];

		const customFieldColumns = {
			friendlyName: 'Name',
			connectedPrinterCount: 'Connected Printers',
		};
		const defaultFieldTypes = {
			friendlyName: 'text',
			connectedPrinterCount: 'number',
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(customFieldColumns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: customFieldColumns[cfc],
				key: cfc,
				value: cfc,
				type: (defaultFieldTypes && defaultFieldTypes[cfc]) || typeof defaultFieldTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		this.state = {
			editedFields: props.fields,
			customFields: this.props.fields.map((category) => {
				const title = category.title;
				const headers = category.fields.map((field) => {
					const name = field.fieldName;
					return {
						_id: field._id,
						fieldName: field.fieldName,
						fieldType: field.fieldType,
						category: title,
						categoryId: category._id,
						required: false,
						disabled: false,
						value: name,
						label: name,
						propertyType: 'attendee'
					};
				});
				return {
					_id: category._id,
					title: `${title}`,
					fields: headers,
					label: title,
					value: category._id,
					options: headers
				};
			}),
			checkInAppConfiguration: {
				enableQRScanner: false,
				enableWalkInCheckIn: false,
				enableSessionCheckIn: false,
				pin: '',
				checkInForm: null,
				walkInForm: null,
				sessionCheckInForm: null,
				useCheckinFormForWalkIn: false,
				useCheckinFormForSession: false,
				showProfilePicture: false,
				showQRCode: false,
				enableConsentScreen: false,
				consentScreen: '',
				backgroundBanner: '',
				name: '',
				shortName: '',
				description: '',
				backgroundColor: '',
				themeColor: '',
				icons: {
					small: '',
					medium: '',
					large: ''
				},
				badgeConfiguration: {
					badgeWidth: 88,
					badgeHeight: 140,
					fieldsConfig: [],
					enableQRCode: true,
					qrCode: { x: 6.7, y: 96.1, size: 25 },
					backgroundImage: 'https://assets-simpleevents.s3.amazonaws.com/betaorg/SE_66c8ca9f1913e99e9baebe93/assets/BADGETEMPLATE%20in%20MM.png',
					includeBackground: false
				}
			},
			baseConfiguration: null,
			uploadingCheckinBanner: false,
			tabs,
			checkinFormEditorModalOpen: false,
			walkInFormEditorModalOpen: false,
			sessionCheckInFormEditorModalOpen: false,
			editingFormBuilder: false,
			editedForm: null,
			form: null,
			editCount: 0,
			error: null,
			editing: false,
			linkCopied: false,
			guideCopied: false,
			toggleAddSimpleZebraModal: false,
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			toggleRenamePrinterModal: false,
			toggleDisconnectPrinterModal: false,
			selectedRow: null,
			toggleDisconnectPrinterModal: false,
			badgeEditorModalOpen: false,
			updatedAt: '',
			loading: true
		};

		// Initialize form manager
		this.formManager = new FormManager(this);
	}

	componentDidMount() {
		const { orgId, eventId } = this.props;

		API().get(`Organizations/${orgId}/events/${eventId}/checkIn`).then((res) => {

			if (res.data) {
				const { walkInForm, checkInForm, sessionCheckInForm, enableSessionCheckIn, enableWalkInCheckIn, enableBadgePrinting } = res.data;

				let tabs = [{ title: 'Setup', id: 'setup' }, { title: 'Configure', id: 'configure' }, { title: 'Check-In Form', id: 'checkInForm' }];
				if (enableWalkInCheckIn) {
					tabs.push({ title: 'Walk-In Registration Form', id: 'walkInForm' });
				}
				if (enableSessionCheckIn) {
					tabs.push({ title: 'Session Check-In Form', id: 'sessionCheckIn' });
				}

				/* if (enableBadgePrinting) {
					tabs.push({ title: 'Badge Printing', id: 'badgePrinting' });
				} */

				tabs.push({ title: 'Deploy', id: 'deploy' });
				if (enableBadgePrinting) {
					tabs.push({ title: 'Printers', id: 'simpleZebra' });
				}


				try {
					// Create deep copies of forms to avoid reference issues
					const formCopies = {
						checkInForm: checkInForm ? JSON.parse(JSON.stringify(checkInForm)) : null,
						walkInForm: walkInForm ? JSON.parse(JSON.stringify(walkInForm)) : null,
						sessionCheckInForm: sessionCheckInForm ? JSON.parse(JSON.stringify(sessionCheckInForm)) : null
					};

					// Validate and initialize form structures
					Object.keys(formCopies).forEach(key => {
						if (formCopies[key] && !formCopies[key]?.pages?.[0]?.sections) {
							formCopies[key].pages = [{
								title: 'Check In',
								subtitle: '',
								sections: [{
									_id: `section_${Date.now()}`,
									title: '',
									fields: [],
									buttons: []
								}]
							}];
						}
					});

					// Initialize configuration with validated forms
					const updatedConfig = {
						...res.data,
						...formCopies
					};
					updatedConfig.icons = updatedConfig.icons || {};
					updatedConfig.splashScreens = updatedConfig.splashScreens || {};

					this.setState({
						checkInAppConfiguration: updatedConfig,
						baseConfiguration: JSON.parse(JSON.stringify(updatedConfig)),
						loading: false,
						selectedSection: 'setup',
						tabs,
						editCount: 0,
						editedForm: null,
						form: null,
						editing: false,
						editingFormBuilder: false,
						error: null
					});
				} catch (error) {
					console.error('Failed to initialize forms:', error);
					this.setState({
						error: 'Failed to initialize forms. Please refresh the page.',
						loading: false
					});
				}

			}

		});
	}

	// Save check-in app configuration with proper error handling
	saveCheckInAppConfiguration = async () => {
		const { orgId, eventId } = this.props;
		const { checkInAppConfiguration } = this.state;

		let error = null;

		// Always validate admin pin
		if (!checkInAppConfiguration.pin || checkInAppConfiguration.pin.toString().length !== 4) {
			error = 'Please enter a 4 digit admin pin';
		}

		// Validate session pin when session check-in is enabled
		if (checkInAppConfiguration.enableSessionCheckIn && (!checkInAppConfiguration.sessionPin || checkInAppConfiguration.sessionPin.toString().length !== 4)) {
			error = 'Please enter a 4 digit session check-in pin';
		}

		if (checkInAppConfiguration.enabled) {
			if (!checkInAppConfiguration.checkInForm) {
				error = 'Check-in form is required or app must be disabled';
			}
			if (checkInAppConfiguration.enableWalkInCheckIn && !checkInAppConfiguration.useCheckinFormForWalkIn && !checkInAppConfiguration.walkInForm) {
				error = 'Walk-in form is required if not using check-in form';
			}
			if (checkInAppConfiguration.enableSessionCheckIn && !checkInAppConfiguration.useCheckinFormForSession && !checkInAppConfiguration.sessionCheckInForm) {
				error = 'Session check-in form is required if not using check-in form';
			}
		}

		if (error) {
			this.setState({ error });
			return;
		}

		try {
			// Create payload with form IDs
			const payload = { ...checkInAppConfiguration };

			// Clean up form references
			['sessionCheckInForm', 'walkInForm', 'checkInForm'].forEach(formKey => {
				if (!payload[formKey]) {
					delete payload[formKey];
				} else {
					payload[formKey] = payload[formKey]._id;
				}
			});

			const response = await API().patch(
				`Organizations/${orgId}/events/${eventId}/saveCheckIn`,
				payload
			);

			if (response.data) {
				this.setState({
					checkInAppConfiguration: response.data,
					baseConfiguration: JSON.parse(JSON.stringify(response.data)),
					editing: false
				});
			}
		} catch (error) {
			console.error('Failed to save check-in configuration:', error);
			// Here you could add proper error handling UI feedback
			this.setState({
				error: 'Failed to save configuration. Please try again.'
			});
		}
	}

	cancelEdit = () => {
		const { baseConfiguration } = this.state;
		let tabs = [
			{ title: 'Setup', id: 'setup' },
			{ title: 'Configure', id: 'configure' },
			{ title: 'Check-In Form', id: 'checkInForm' }
		];
		if (baseConfiguration.enableWalkInCheckIn) {
			tabs.push({ title: 'Walk-In Registration Form', id: 'walkInForm' });
		}
		if (baseConfiguration.enableSessionCheckIn) {
			tabs.push({ title: 'Session Check-In Form', id: 'sessionCheckIn' });
		}
		tabs.push({ title: 'Deploy', id: 'deploy' });
		if (baseConfiguration.enableBadgePrinting) {
			tabs.push({ title: 'Printers', id: 'simpleZebra' });
		}

		this.setState({
			editing: false,
			checkInAppConfiguration: JSON.parse(JSON.stringify(baseConfiguration)),
			error: null,
			tabs,
		});
	}

	handleCopyGuide = () => {
		const guideContent = `
		For iOS Devices:
		1. Open the event link in Safari.
		2. Tap the Share button (square with an arrow).
		3. Scroll and select "Add to Home Screen".
		4. Name the app (if desired).
		5. Tap "Add".
		6. The app icon will now appear on your home screen.

		Troubleshooting:
		• Ensure you're using Safari.
		• Check that your iOS is up to date.
		• Close and reopen Safari if needed.
		• Verify you have sufficient device storage.

		For Android Devices:
		1. Open the event link in your mobile browser.
		2. Tap the "Add to Home Screen" button in the browser menu.
		3. Tap "Add" or "Install" in the pop-up window.
		4. The app icon will now appear on your home screen.

		Troubleshooting:
		• If no prompt appears, look for the browser's menu (three dots).
		• Select "Add to Home Screen" from the menu.
		• Ensure you have enough storage space.
		• Restart your browser if installation fails.
        `;

		navigator.clipboard
			.writeText(guideContent)
			.then(() => {
				this.setState({ guideCopied: true });
				setTimeout(() => {
					this.setState({ guideCopied: false });
				}, 2000);
			})
			.catch((err) => console.error("Failed to copy guide:", err));
	};


	handleCopyEventLink = () => {
		const link = this.props.org.hostname ? `https://${this.props.org.hostname}/${this.props.event.nameSlug}/CheckinApp` : `https://${this.props.org.identifier}.simple.events/${this.props.event.nameSlug}/CheckinApp`;
		navigator.clipboard
			.writeText(link)
			.then(() => {
				this.setState({ linkCopied: true });
				setTimeout(() => {
					this.setState({ linkCopied: false });
				}, 2000);
			})
			.catch((err) => console.error("Failed to copy link:", err));
	};
	updateCustomFields = (CustomFieldData) => {
		const updatedCustomFields = [...this.state.customFields];

		// Find if category already exists
		const existingCategoryIndex = updatedCustomFields.findIndex(
			category => category.title === CustomFieldData.title
		);

		if (existingCategoryIndex > -1) {
			// Add new field to existing category
			const newField = {
				_id: CustomFieldData.fields[CustomFieldData.fields.length - 1]._id,
				fieldName: CustomFieldData.fields[CustomFieldData.fields.length - 1].fieldName,
				fieldType: CustomFieldData.fields[CustomFieldData.fields.length - 1].fieldType,
				required: false,
				disabled: false,
				propertyType: 'attendee'
			};
			updatedCustomFields[existingCategoryIndex].fields.push(newField);
		} else {
			const newCategory = {
				_id: CustomFieldData.fields[CustomFieldData.fields.length - 1]._id,
				title: CustomFieldData.title,
				fields: CustomFieldData.fields.map((field) => ({
					_id: field._id,
					fieldName: field.fieldName,
					fieldType: field.fieldType,
					required: false,
					disabled: false,
					propertyType: 'attendee'
				}))
			};
			updatedCustomFields.push(newCategory);
		}

		this.setState({ customFields: updatedCustomFields });
	};

	toggleAddSimpleZebraModal = () => {

		this.setState({
			toggleAddSimpleZebraModal: !this.state.toggleAddSimpleZebraModal
		});
	};

	updatedActiveSimpleZebraDevices = (activeSimpleZebraDevices) => {
		this.setState({ checkInAppConfiguration: { ...this.state.checkInAppConfiguration, zebraPrinters: activeSimpleZebraDevices } });
	};

	toggleRenamePrinterModal = (id) => {
		const { toggleRenamePrinterModal } = this.state;
		this.setState({ toggleRenamePrinterModal: !toggleRenamePrinterModal, selectedRow: id });
	};

	toggleDisconnectPrinterModal = (id) => {
		const { toggleDisconnectPrinterModal } = this.state;
		this.setState({ toggleDisconnectPrinterModal: !toggleDisconnectPrinterModal, selectedRow: id });
	};

	renderSection = () => {
		const { selectedSection, checkInAppConfiguration } = this.state;

		const { orgId, eventId, event } = this.props;
		switch (selectedSection) {
			case 'setup':
				return <CheckinSetup
					checkInAppConfiguration={checkInAppConfiguration}
					handleChange={this.handleChange}
					orgId={orgId}
					eventId={eventId}
					uploadingCheckinBanner={this.state.uploadingCheckinBanner}
					updateUploadingCheckinBanner={(val) => {
						this.setState({ uploadingCheckinBanner: val });
					}}
					event={event}
					onOpenBadgeEditor={() => {
						this.setState({ badgeEditorModalOpen: true });
					}}
				/>
			case 'configure':
				return <ConfigureCheckin
					checkInAppConfiguration={checkInAppConfiguration}
					handleChange={this.handleChange}
					orgId={orgId}
					eventId={eventId}
					uploadingCheckinBanner={this.state.uploadingCheckinBanner}
					updateUploadingCheckinBanner={(val) => {
						this.setState({ uploadingCheckinBanner: val });
					}}
					event={event}
				/>
			case 'badgePrinting':
				return (
					<div className="sectionBody">
						<div className='blocksContainer'>
							<div className='flex w-100'>
								<div className="sectionBlock mr-25 contained-h">
									<h2 className='blockHeader'>Setup</h2>
									<SelectField
										label="Select Badge Size"
										value={checkInAppConfiguration.badgeSize}
										options={[
											{ value: '2x3', label: '2x3' },
											{ value: '3x4', label: '3x4' },
											{ value: '4x6', label: '4x6' },
											{ value: 'custom', label: 'Custom' },
										]}
										onChange={(e) => {
											this.handleChange({ badgeSize: e.target.value });
										}}
									/>
									{checkInAppConfiguration.badgeSize === 'custom' && <div className="flex">
										<InputField
											label="Width"
											value={checkInAppConfiguration.customBadgeWidth}
											type="number"
											onChange={(e) => {
												this.handleChange({ customBadgeWidth: e.target.value });
											}}
										/>
										<InputField
											label="Height"
											value={checkInAppConfiguration.customBadgeHeight}
											type="number"
											onChange={(e) => {
												this.handleChange({ customBadgeHeight: e.target.value });
											}}
										/>
									</div>}
									<h2 className='blockHeader'>Design</h2>
									<div className="editorFileInput">
										<FileChooserPreview
											label="Badge Background Image"
											value={checkInAppConfiguration.badgeBackground}
											clearFile={() => {
												this.setState({
													checkInAppConfiguration: {
														...this.state.checkInAppConfiguration,
														badgeBackground: "",
													},
													editCount: this.state.editCount + 1,
													editing: true,
												});
											}}
											onClick={(e) => {
												this.setState({ uploadingBadgeBackground: true });
											}}
										/>
										<FilesUploaderModal
											title="Image"
											links={{
												getAssets: `Organizations/${orgId}/events/${eventId}/assets`,
												addAssets: `Organizations/${orgId}/events/${eventId}/assets`,
											}}
											isOpen={this.state.uploadingBadgeBackground}
											toggle={() => {
												this.setState({
													uploadingBadgeBackground: false,
												});
											}}
											orgId={orgId}
											addFiles={(fileURL) => {
												this.setState({
													checkInAppConfiguration: {
														...this.state.checkInAppConfiguration,
														badgeBackground: fileURL,
													},
													editCount: this.state.editCount + 1,
													editing: true,
													uploadingBadgeBackground: false,
												});
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				);

			case 'checkInForm':
				let checkInFormId = !checkInAppConfiguration.checkInForm ? null : checkInAppConfiguration.checkInForm._id;
				return <CheckinFormSetup
					checkInAppConfiguration={checkInAppConfiguration}
					handleChange={this.handleChange}
					orgId={orgId}
					eventId={eventId}
					checkInFormId={checkInFormId}
					formManager={this.formManager}
					editCount={this.state.editCount}
					account={this.props.account}
					event={event}
				/>
			case 'walkInForm':
				let walkInFormId = !checkInAppConfiguration.walkInForm ? null : checkInAppConfiguration.walkInForm._id;
				return <WalkinFormSetup
					checkInAppConfiguration={checkInAppConfiguration}
					handleChange={this.handleChange}
					orgId={orgId}
					eventId={eventId}
					walkInFormId={walkInFormId}
					formManager={this.formManager}
					editCount={this.state.editCount}
					account={this.props.account}
					event={event}
				/>
			case 'sessionCheckIn':
				let sessionCheckInFormId = !checkInAppConfiguration.sessionCheckInForm ? null : checkInAppConfiguration.sessionCheckInForm._id;
				return <SessionCheckinSetup
					checkInAppConfiguration={checkInAppConfiguration}
					handleChange={this.handleChange}
					orgId={orgId}
					eventId={eventId}
					sessionCheckInFormId={sessionCheckInFormId}
					formManager={this.formManager}
					editCount={this.state.editCount}
					account={this.props.account}
					event={event}
				/>
			case 'deploy':
				let configurationComplete = true;
				let missingCheckinForm = false;
				let missingConfiguration = false;
				let missingWalkInForm = false;
				let missingSessionForm = false;
				let missingConsentScreen = false;
				let pinValid = false;
				if (checkInAppConfiguration.checkInForm === null) {
					configurationComplete = false;
					missingCheckinForm = true;
				}
				if (checkInAppConfiguration.enableWalkInCheckIn && !checkInAppConfiguration.useCheckinFormForWalkIn && checkInAppConfiguration.walkInForm === null) {
					configurationComplete = false;
					missingWalkInForm = true;
				}
				if (checkInAppConfiguration.enableSessionCheckIn && !checkInAppConfiguration.useCheckinFormForSession && checkInAppConfiguration.sessionCheckInForm === null) {
					configurationComplete = false;
					missingSessionForm = true;
				}

				if (checkInAppConfiguration.pin.length === 4) {
					pinValid = true;
				} else {
					configurationComplete = false;
				}

				if (checkInAppConfiguration.enableConsentScreen && checkInAppConfiguration.consentScreen === '') {
					configurationComplete = false;
					missingConsentScreen = true;
				}

				const configComplete = checkInAppConfiguration.name !== "" &&
					checkInAppConfiguration.shortName !== "" &&
					checkInAppConfiguration.description !== "" &&
					checkInAppConfiguration.backgroundColor !== "" &&
					checkInAppConfiguration.themeColor !== "" &&
					checkInAppConfiguration.brandColor !== "" &&
					checkInAppConfiguration.buttonTextColor !== "";
				if (!configComplete) {
					configurationComplete = false;
					missingConfiguration = true;
				}


				return <div className="sectionBody">
					<div className='blocksContainer'>
						<div className='flex w-100'>
							<div className="sectionBlock mr-25 contained-h">
								<div className="outlineCard">
									<p className="mb-20">
										This guide will walk you through the quick and easy process of deploying your event's check-in app.
										To ensure a smooth experience for your attendees, please make sure to complete the following steps.
										Once complete, the app should be installed on the devices that will be used on site or shared with event staff.

									</p>
									<ToggleField
										label={<strong>Get started by enabling the app</strong>}
										icons={false}
										checked={checkInAppConfiguration.enabled}
										disabled={!configurationComplete}
										onChange={(val) => {
											this.setState({
												checkInAppConfiguration: {
													...checkInAppConfiguration,
													enabled: val.target.checked,
												},
												editCount: this.state.editCount + 1,
												editing: true,
											});
										}}
									/>
									{configurationComplete ? null : (
										<div>
											<p className="mt-20 mb-20 modalErrorMessage small">
												It appears that the application setup is incomplete.<br />
												Please finish setting up the unchecked items to enable the app:
											</p>
										</div>
									)}

									<div
										className={`mt-10 flex aic gap5 ${!missingCheckinForm ? "blue" : "neu"}`}
									>
										{!missingCheckinForm ? <i
											className={`las la-check-circle`}
										></i> : <i className=" las la-times-circle"></i>}
										<p className={`small`}>
											Checkin form
										</p>
									</div>
									<div
										className={`mt-10 flex aic gap5 ${!missingConfiguration ? "blue" : "neu"}`}
									>
										{!missingConfiguration ? <i
											className={`las la-check-circle`}
										></i> : <i className=" las la-times-circle"></i>}
										<p className={`small`}>
											Configure
										</p>
									</div>
									{checkInAppConfiguration.enableWalkInCheckIn && (
										<div
											className={`mt-10 flex aic gap5 ${!missingWalkInForm ? "blue" : "neu"}`}
										>
											{!missingWalkInForm ? <i
												className={`las la-check-circle`}
											></i> : <i className=" las la-times-circle"></i>}
											<p className={`small`}>
												Walkin registration form
											</p>
										</div>
									)}

									{checkInAppConfiguration.enableSessionCheckIn && (
										<div
											className={`mt-10 flex aic gap5 ${!missingSessionForm ? "blue" : "neu"}`}
										>
											{!missingSessionForm ? <i
												className={`las la-check-circle`}
											></i> : <i className=" las la-times-circle"></i>}
											<p className={`small`}>
												Session checkin form
											</p>
										</div>
									)}

									{checkInAppConfiguration.enableConsentScreen && (
										<div
											className={`mt-10 flex aic gap5 ${!missingConsentScreen ? "blue" : "neu"}`}
										>
											{!missingConsentScreen ? <i
												className={`las la-check-circle`}
											></i> : <i className=" las la-times-circle"></i>}
											<p className={`small`}>
												Consent screen
											</p>
										</div>
									)}

									<div className={`mt-10 flex aic gap5 ${pinValid ? "blue" : "neu"}`}>
										{pinValid ? <i
											className={`las la-check-circle`}
										></i> : <i className=" las la-times-circle"></i>}
										<p className={`small`}>
											Admin Pin
										</p>
									</div>

								</div>
								{checkInAppConfiguration.enabled && <>
									<div>
										<h2 className="blockHeader">Share with your Staff</h2>
										<div
											className={`flex aic gap10`}
										>
											<InputField
												label="Send this link to your staff to still app on devices."
												required={false}
												disabled={true}
												placeholder={`${this.props.event.nameSlug}/CheckinApp`}
												value={this.props.org.hostname ?
													`https://${this.props.org.hostname}/${this.props.event.nameSlug}/CheckinApp` :
													`https://${this.props.org.identifier}.simple.events/${this.props.event.nameSlug}/CheckinApp`
												}
												readOnly
											/>
											<button className={`neu ${this.state.linkCopied ? 'disabled' : ''}`} onClick={this.handleCopyEventLink}>
												{this.state.linkCopied ? 'Link Copied' : `Copy link`}
											</button>
										</div>
									</div>
									<div>
										<h2 className="blockHeader">App Installation Instructions</h2>
										<p className="mb-20">
											Help your staff install the app with this simple guide.
											Copy the guide to your clipboard and paste it along with your
											app link.
										</p>
									</div>
									<button className={`neu mt-20 ${this.state.guideCopied ? 'disabled' : ''}`} onClick={this.handleCopyGuide}>
										{this.state.guideCopied ? `Link Copied` : `Copy Guide to Clipboard`}
									</button>
									<div>
										<h1 className="sectionName mt-20"><i className="lab la-apple mr-10"></i>For iOS Devices</h1>
										<p className="mt-10">1. Open the event link in Safari</p>
										<p className="mt-10">
											2. Tap the Share button (square with an arrow)
										</p>
										<p className="mt-10">
											3. Scroll and select "Add to Home Screen"
										</p>
										<p className="mt-10">4. Name the app (if desired)</p>
										<p className="mt-10">5. Tap "Add"</p>
										<p className="mt-10">
											6. The app icon will now appear on your home screen
										</p>
										<h2 className="blockHeader">Troubleshooting</h2>
										<ul>
											<li className="mt-10">Ensure you're using Safari</li>
											<li className="mt-10">Check that your iOS is up to date</li>
											<li className="mt-10">Close and reopen Safari if needed</li>
											<li className="mt-10">
												Verify you have sufficient device storage
											</li>
										</ul>
									</div>
									<div>
										<h1 className="sectionName mt-20"><i className="lab la-android mr-10"></i>For Android Devices</h1>
										<p className="mt-10">
											1. Open the event link in your mobile browser{" "}
										</p>
										<p className="mt-10">
											2. Tap the "Add to Home Screen" button in the browser menu
										</p>
										<p className="mt-10">
											3. Tap "Add" or "Install" in the pop-up window
										</p>
										<p className="mt-10">
											4. The app icon will now appear on your home screen
										</p>
										<h2 className="blockHeader">Troubleshooting</h2>
										<ul>
											<li className="mt-10">
												If no prompt appears, look for the browser's menu (three dots)
											</li>
											<li className="mt-10">
												Select "Add to Home Screen" from the menu
											</li>
											<li className="mt-10">
												Ensure you have enough storage space
											</li>
											<li className="mt-10">
												Restart your browser if installation fails
											</li>
										</ul>
									</div>
								</>}
							</div>
						</div>
					</div>
				</div>
			case 'simpleZebra':
				const { toggleAddSimpleZebraModal, normalizedColumns, toggledColumns, toggleRenamePrinterModal, selectedRow, toggleDisconnectPrinterModal } = this.state;

				let activeSimpleZebraDevices = checkInAppConfiguration.zebraPrinters || [];
				activeSimpleZebraDevices = activeSimpleZebraDevices.map((device) => {
					return {
						...device,
						connectedPrinterCount: device.ports ? device.ports.length : 0
					};
				});
				return (
					<div className="sectionContainer sectionBody">
						<ActionButtonContainer
							mainActions={[
								{ onClick: this.toggleAddSimpleZebraModal, label: 'Add Printer' },
							]}
							searchEnabled={false}
							searchEntries={() => { }}
						/>

						<div className='flex h-100 hasHeader'>
							<ViewsTable
								title={'Printers'}
								columns={normalizedColumns}
								toggledColumns={toggledColumns}
								data={activeSimpleZebraDevices}
								mainColumnActive={false}
								checked={{}}
								disableCheck={true}
								sortData={() => { }}
								defaultSort={'name'}
								sortDirection={'desc'}
								rowSettings={[
									{ label: <span><i className='las la-pen mr-10'></i>Rename Printer</span>, onClick: this.toggleRenamePrinterModal },
									{ label: <span><i className='las la-times mr-10'></i>Disconnect Printer</span>, onClick: this.toggleDisconnectPrinterModal }

								]}
							/>
						</div>

						{toggleAddSimpleZebraModal &&
							<AddSimpleZebraDeviceModal
								orgId={orgId}
								eventId={eventId}
								isOpen={toggleAddSimpleZebraModal}
								toggle={this.toggleAddSimpleZebraModal}
								updatedActiveSimpleZebraDevices={this.updatedActiveSimpleZebraDevices}
								checkInAppConfiguration={checkInAppConfiguration}
							/>
						}

						{toggleRenamePrinterModal &&
							<RenamePrinterModal
								orgId={orgId}
								eventId={eventId}
								isOpen={toggleRenamePrinterModal}
								toggle={this.toggleRenamePrinterModal}
								updatedActiveSimpleZebraDevices={this.updatedActiveSimpleZebraDevices}
								checkInAppConfiguration={checkInAppConfiguration}
								printer={activeSimpleZebraDevices.find((device) => device._id === selectedRow)}
							/>
						}

						{toggleDisconnectPrinterModal &&
							<DisconnectPrinterModal
								orgId={orgId}
								eventId={eventId}
								isOpen={toggleDisconnectPrinterModal}
								toggle={this.toggleDisconnectPrinterModal}
								updatedActiveSimpleZebraDevices={this.updatedActiveSimpleZebraDevices}
								checkInAppConfiguration={checkInAppConfiguration}
								printer={activeSimpleZebraDevices.find((device) => device._id === selectedRow)}
							/>
						}



					</div>
				);
			default:
				return null;
		}

	}

	// Handle configuration changes with validation and state updates
	handleChange = async (changeObj, hiddenEdit) => {

		this.setState(prevState => {
			const updatedConfig = {
				...prevState.checkInAppConfiguration,
				...changeObj
			};

			// Update tabs if enabling/disabling walk-in or session check-in
			let updatedTabs = [...prevState.tabs];
			if ('enableWalkInCheckIn' in changeObj || 'enableSessionCheckIn' in changeObj || 'enableBadgePrinting' in changeObj) {
				// Always include Setup and Check In Form
				updatedTabs = [
					{ title: 'Setup', id: 'setup' },
					{ title: 'Configure', id: 'configure' },
					{ title: 'Check-In Form', id: 'checkInForm' }
				];

				// Add conditional tabs
				if (updatedConfig.enableWalkInCheckIn) {
					updatedTabs.push({ title: 'Walk-In Registration Form', id: 'walkInForm' });
				}
				if (updatedConfig.enableSessionCheckIn) {
					updatedTabs.push({ title: 'Session Check-In Form', id: 'sessionCheckIn' });
				}

				// Always include Deploy tab at the end
				updatedTabs.push({ title: 'Deploy', id: 'deploy' });
				if (updatedConfig.enableBadgePrinting) {
					updatedTabs.push({ title: 'Printers', id: 'simpleZebra' });
				}
			}

			// Handle pin validation
			if ('pin' in changeObj) {
				const pin = changeObj.pin.toString();
				if (pin.length > 4) {
					return null; // Don't update state if pin is too long
				}
			}

			return {
				checkInAppConfiguration: updatedConfig,
				tabs: updatedTabs,
				editing: !hiddenEdit,
				error: null // Clear any previous errors
			};
		});
	};

	updateSelected = (index) => {
		const { tabs } = this.state;
		this.setState({ selectedSection: tabs[index].id });
	};

	render() {
		const {
			loading,
			selectedSection,
			editing,
			checkInAppConfiguration,
			tabs,
			checkinFormEditorModalOpen,
			walkInFormEditorModalOpen,
			sessionCheckInFormEditorModalOpen,
			editingFormBuilder
		} = this.state;

		const { event } = this.props;

		return (
			<div className="sectionContainer">
				{loading && <LoadingWizard loading={loading} text={"Loading Check In App"} />}
				{!loading && (
					<SectionHeader
						title={"Check In App"}
						breadcrumbs={[
							{
								name: event.name
							}
						]}
					>
						<TabContainer
							tabs={tabs}
							updateSelected={this.updateSelected}
							selectedIndex={tabs.findIndex((tab) => tab.id === selectedSection)}
						/>
					</SectionHeader>
				)}

				{!loading && this.renderSection()}
				{this.state.error && (
					<div className="error-message mb-20" style={{ color: 'red', padding: '10px', textAlign: 'center' }}>
						{this.state.error}
					</div>
				)}
				{!loading && (
					<SectionFooter
						updatedAt={checkInAppConfiguration.updatedAt}
						saveEdit={this.saveCheckInAppConfiguration}
						cancelEdit={this.cancelEdit}
						editing={editing}
						lastEditedBy={''}
					/>
				)}

				{checkinFormEditorModalOpen &&
					<CheckInFormBuilderModal
						limitPages={true}
						isOpen={checkinFormEditorModalOpen}
						editing={editingFormBuilder}
						toggle={() => this.setState({
							checkinFormEditorModalOpen: false,
							editedForm: null,
							form: null,
							editingFormBuilder: false,
							error: null
						})}
						form={this.state.form || checkInAppConfiguration.checkInForm}
						editedForm={this.state.editedForm || checkInAppConfiguration.checkInForm}
						fields={this.props.fields}
						baseFieldList={[...baseFieldList]}
						links={{ get: `` }}
						updateForm={(form) => this.formManager.updateForm('checkInForm', form)}
						cancelEdit={this.formManager.cancelEdit}
						emails={this.props.availableEmails}
						orgId={this.props.orgId}
						eventId={this.props.eventId}
						addNewField={this.props.addNewField}
						saveForm={this.formManager.saveForm}
						customFieldList={[...this.state.customFields]}
						groups={this.props.event.groups}
						updateCustomFields={this.updateCustomFields}
					/>
				}
				{walkInFormEditorModalOpen &&
					<CheckInFormBuilderModal
						limitPages={true}
						isOpen={walkInFormEditorModalOpen}
						editing={editingFormBuilder}
						toggle={() => this.setState({
							walkInFormEditorModalOpen: false,
							editedForm: null,
							form: null,
							editingFormBuilder: false,
							error: null
						})}
						form={this.state.form || checkInAppConfiguration.walkInForm}
						editedForm={this.state.editedForm || checkInAppConfiguration.walkInForm}
						fields={this.props.fields}
						baseFieldList={[...baseFieldList]}
						links={{ get: `` }}
						updateForm={(form) => this.formManager.updateForm('walkInForm', form)}
						cancelEdit={this.formManager.cancelEdit}
						emails={this.props.availableEmails}
						orgId={this.props.orgId}
						eventId={this.props.eventId}
						addNewField={this.props.addNewField}
						saveForm={this.formManager.saveForm}
						customFieldList={[...this.state.customFields]}
						groups={this.props.event.groups}
						updateCustomFields={this.updateCustomFields}
					/>
				}
				{sessionCheckInFormEditorModalOpen &&
					<CheckInFormBuilderModal
						limitPages={true}
						isOpen={sessionCheckInFormEditorModalOpen}
						editing={editingFormBuilder}
						toggle={() => this.setState({
							sessionCheckInFormEditorModalOpen: false,
							editedForm: null,
							form: null,
							editingFormBuilder: false,
							error: null
						})}
						form={this.state.form || checkInAppConfiguration.sessionCheckInForm}
						editedForm={this.state.editedForm || checkInAppConfiguration.sessionCheckInForm}
						fields={this.props.fields}
						baseFieldList={[...baseFieldList]}
						links={{ get: `` }}
						updateForm={(form) => this.formManager.updateForm('sessionCheckIn', form)}
						cancelEdit={this.formManager.cancelEdit}
						emails={this.props.availableEmails}
						orgId={this.props.orgId}
						eventId={this.props.eventId}
						addNewField={this.props.addNewField}
						saveForm={this.formManager.saveForm}
						customFieldList={[...this.state.customFields]}
						groups={this.props.event.groups}
						updateCustomFields={this.updateCustomFields}
					/>
				}
				{this.state.badgeEditorModalOpen &&
					<BadgeEditor
						isOpen={this.state.badgeEditorModalOpen}
						toggle={() => this.setState({ badgeEditorModalOpen: false })}
						eventId={this.props.eventId}
						orgId={this.props.orgId}
						initialConfig={checkInAppConfiguration.badgeConfiguration}
						links={{
							getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
							addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
						}}
						handleChange={this.handleChange}
						saveCheckInAppConfiguration={this.saveCheckInAppConfiguration}
					/>
				}
			</div>
		);
	}
}

export default withRouter(CheckInAppSetup);
